import React from 'react';
import Image from 'next/image';
import Head from 'next/head';

import styles from '../styles/About.module.scss';
import Link from 'next/link';

const Story = () => {
  return (
    <>
      <Head>
        <title>About us | Noundles</title>
      </Head>
      <div className="pink-gradient">
        <div className={styles.rainbow}>
          <div className={styles.hero}>
            <div className="container">
              <div className="row">
                <div className="col-12 col-md-5 d-flex flex-column justify-content-end">
                  <Image src="/book.png" alt="Book" width={894} height={894} />
                </div>
                <div className="col-12 col-md-7 d-flex flex-column justify-content-center order-first order-md-last">
                  <h1 className="display-4 title mb-3">The Noundles Story</h1>
                  <p className="lead">
                    Noundles is a community-led PFP collection inspired by{' '}
                    <a
                      href="https://nouns.wtf/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Nouns DAO
                    </a>{' '}
                    with a little smoothed out funk. Supported by a die-hard
                    community, committed leadership, and shared voting power
                    across holders, our mission is to champion all things
                    different and build a more inclusive space for those looking
                    for a place to belong.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="my-5 pt-5">
            <h2 className="display-4 title mb-3">Part One: Genesis</h2>
            <div className="lead my-3">
              <p>
                The Noundles Story began where all good stories begin, with a
                great idea. What happens when you take the public domain art
                from Web3 innovators NounsDAO, and mix it up with a little bit
                of smoothed out funk? Early glimpses of Noundles began to
                circulate in October 2021, just a couple of weeks after the
                Doodles NFT project dropped with a splash. Inspiration from the
                Doodles community propelled the project forward - Noundles hoped
                to bridge the NounsDAO and Doodles communities, and extend new
                modes of collaboration out across the NFT space.
              </p>
              <p>
                Noundles was originally proposed as a PFP collection that
                generated daily $rainbows tokens for access to something called
                “The Noundle Grail” - it was all very mysterious and new, and
                excitement was building.
              </p>
              <p>
                Original founders, [REDACTED], minted their project in November
                to great acclaim. People loved the Noundles. A 0.04 ETH mint
                price rose to a 0.33 ETH floor within a week. The enthusiasm was
                palpable and the Noundles were feeling both smoothed out and
                funky.
              </p>
              <p>
                A surprise update from [REDACTED] generated new excitement and
                attention from other corners of the NFT space - the Noundles
                that were minted would now play a role in a P2E game, similar to
                others that were riding waves to the top. Another collection was
                going to drop, and these would add new dynamics to the
                accumulation of $rainbows. Things were starting to get
                complicated, but in a good way?
              </p>
            </div>
          </div>
          <div className="my-5 pt-5">
            <h2 className="display-4 title mb-3">Part Two: Game Theory</h2>
            <div className="lead my-3">
              <p>
                The new collection minted, and the game was ready to launch. The
                energy was bubbling, and Noundles were flying, soaring to a high
                of 0.935 ETH as the project rode into Thanksgiving.
              </p>
              <p>
                Everything was lining up perfectly, until suddenly it
                wasn&apos;t.
              </p>
              <p>
                Hours before the game was set to drop, the original team of
                [REDACTED] were notified of a bug that would have damaged the
                game instantly upon release. An emergency brake was thrown. The
                bug had to be fixed.
              </p>
              <p>And panic ensued.</p>
              <p>
                For a week, [REDACTED] attempted to patch the bug and solve an
                array of new problems, while the Noundles community clamored for
                updates and answers. The absence of any direction from
                [REDACTED] led to a massive drop in confidence, and just as
                quickly as Noundles rose it began to fall.
              </p>
              <p>
                [REDACTED] returned, explained the problem, and informed the
                Discord community that in order for the game to work, a mass
                migration would have to occur to bring the new collection over
                to a different contract. There were explanations, promises, and
                descriptions of a new vision. There was a whole lot of talk, and
                it all seemed to sort of make sense? Then [REDACTED] injected 44
                ETH from the Community Wallet into the liquidity pool for
                $rainbows, and it all evaporated within a matter of minutes.
                What was happening?
              </p>
            </div>
          </div>
          <div className="my-5 pt-5">
            <h2 className="display-4 title mb-3">Part Three: Migration</h2>
            <div className="lead my-3">
              <p>
                Things were not going well. The community was in turmoil, the
                game stalled out, and [REDACTED] was floundering. What was the
                plan? Where was the leadership? The fate of the project looked
                dim, and yet many did not give up. Many wanted to believe that
                the path back to earlier heights was within sight, that the devs
                would do something. However, an alarm went out through the
                community as suspicious activity had been identified coming from
                some of the project wallets - large amounts of money were
                transferred mysteriously to hidden sources, and it appeared that
                perhaps there was something more malicious at play. The outrage
                was severe.
              </p>
              <p>
                People loved their Noundles too much to let them meet a ruinous
                demise at the hands of a derelict project team. A couple of
                community mods (@cappy and @EltonPenguin), and the dev (@wkm)
                who had originally identified the bug in the game, were
                beginning to generate a plan that at the time seemed, perhaps,
                too crazy to work - could the community take Noundles over?
              </p>
              <p>
                During this time, multiple group chats and private discords
                sprang up within the community as answers were sought and plans
                were hatched. The original team had lost all confidence and good
                will from the community, so ultimately the community took
                control of its fate. The Noundles community pushed [REDACTED] to
                accept the terms of a community-wide vote via snapshot.org, the
                results of which would replace the original team with a new team
                of trusted and proven leaders derived from the community. The
                vote was decisive, [REDACTED] had to go.
              </p>
            </div>
          </div>
          <div className="my-5 pt-5">
            <h2 className="display-4 title mb-3">Part Four: The Reboundles</h2>
            <div className="lead my-3">
              <p>
                The Transition Team of cappy, EltonPenguin, and wkm worked with
                [REDACTED] on the terms of the takeover. The agreement
                transferred control of all Noundles assets, a 200+ ETH Community
                Wallet, and the Doodle that [REDACTED] had used to enter the
                holder areas on the Doodles server. With new organization and
                new focus, the new leadership team for Noundles embarked upon
                THE REBOUNDLES.
              </p>
              <p>The key goals of The Reboundles were manifold:</p>
              <ul>
                <li>
                  Ensure the security of the Noundles community through
                  transparency and clear communication. All funds would be
                  protected under the control of two five-person multisignature
                  wallets, managed by individuals selected from the community
                  for their skills and expertise.
                </li>
                <li>
                  Continue to grow a community that is collaborative and
                  inclusive.
                </li>
                <li>
                  Establish a clear roadmap for success with deliverable
                  objectives: the Reboundles would build on what had the
                  potential to work, and retool what had failed.
                </li>
                <li>
                  Provide real utility for the $rainbows tokens, which Noundles
                  generate automatically every day.
                </li>
                <li>
                  Reimagine game functionality for Noundles and design new and
                  innovative NFT gaming experiences.
                </li>
                <li>Get the Noundles&apos; swagger back.</li>
              </ul>
              <p>
                With The Reboundles underway, Noundles is repositioned and
                primed to take off once again. The journey to this point has
                been turbulent, but the Noundles remain unfunkwithable. We hope
                you join us!
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Story;
